import { Turnstile } from "@marsidev/react-turnstile"
import {
  Form,
  UnstyledInput,
} from "@tandemdiabetes/sugarmate-react-components"
import { useCallback } from "react"
import type {
  FormEventHandler,
  ReactNode,
} from "react"
import styles from "../AccountForms.module.scss"
import customStyles from "./FeatureAdvisoryForm.module.scss"
import { usePolyglot } from "src/contexts"

interface FeatureAdvisoryForm {
  token: string;
}

interface Props {
  children?: ReactNode;
}

interface Props {
  form: FeatureAdvisoryForm;
  updateForm: (form: Partial<FeatureAdvisoryForm>) => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
  children?: ReactNode;
}

const turnstile = "turnstile-registration-button"
const polyglotPrefix = "components.account_forms.feature_advisory."

export function FeatureAdvisoryForm(props: Props) {
  const {
    children,
    onSubmit,
    form,
    updateForm,
  } = props

  const polyglot = usePolyglot()

  const onTurnstileSuccess = useCallback(
    (newToken: string) => {
      updateForm({ token: newToken })
    },
    [updateForm],
  )

  /*
   * the Turnstile component does not respond to changes on this callback
   * so we are passing a ref for it to access the current state
   */
  const onTurnstileError = useCallback(
    () => {
      updateForm({ token: "" })
    },
    [updateForm],
  )

  return (
    <Form
      className={styles.form}
      onSubmit={onSubmit}
    >
      <div className={customStyles.featureAdvisoryDescription}>
        <div className={styles.description}>
          {polyglot.t(`${polyglotPrefix}description_one`)}
        </div>
        <div className={styles.description}>
          {polyglot.t(`${polyglotPrefix}description_two`)}
        </div>
        <Turnstile
          siteKey={process.env.REACT_APP_TURNSTILE_SITE_KEY ?? ""}
          className={styles.submit}
          onSuccess={onTurnstileSuccess}
          onError={onTurnstileError}
          onExpire={onTurnstileError}
          id={turnstile}
        />
      </div>
      <UnstyledInput // this input forces the token to exist before letting the user submit the form
        value={form.token}
        type="password"
        required
        className={customStyles.tokenInput}
      />
      {children}
    </Form>
  )
}
